var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFavouriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.263 3c.848 0 1.687.202 2.515.606.327.16.64.36.94.598A7.512 7.512 0 0010.5 6v.038l.008.309v.018l.002.02a7.5 7.5 0 007.105 7.105l.02.001.018.001.309.008H18c.85 0 1.668-.143 2.43-.404-.203.285-.425.57-.667.848a68.264 68.264 0 01-4.988 5.135l-1.496 1.402c-.172.179-.374.31-.605.394a2 2 0 01-.684.125c-.225 0-.452-.041-.68-.125a1.594 1.594 0 01-.6-.394l-1.512-1.419A70.537 70.537 0 014.2 13.884C2.733 12.188 2 10.372 2 8.434c0-1.542.504-2.833 1.51-3.873C4.519 3.52 5.77 3 7.264 3z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0a6 6 0 110 12 6 6 0 010-12zm-2 5.25a.75.75 0 000 1.5h4l.077-.004a.75.75 0 000-1.492L20 5.25h-4z",
    fill: "currentColor"
  })));
}
SvgRemoveFavouriteFilled.displayName = 'RemoveFavouriteFilled';
export default SvgRemoveFavouriteFilled;